interface GetSingleSelectSearchValueOptions {
  isMultiselect: boolean | undefined;
  shouldIgnoreDisplayedSingleSelectValue: boolean;
  inputValue: string;
}

// Returns the active search term for server-side filtering.
// Returns empty string for single-select when the displayed value is the already-selected label
// (restored state), so it is not treated as a new search query.
export const getSingleSelectSearchValue = ({
  isMultiselect,
  shouldIgnoreDisplayedSingleSelectValue,
  inputValue,
}: GetSingleSelectSearchValueOptions): string => {
  if (!isMultiselect && shouldIgnoreDisplayedSingleSelectValue) {
    return '';
  }
  return inputValue;
};
